export default __webpack_public_path__ + "static/5-projects-gas-refitting-d6b1d762576dcc18a4d2980725baa7c6.jpg";